export const OPEN_COMPACT_HISTORY_EVENT = "denker:open-compact-history";
